function verifyCallback(response, recaptcha) {
    const element = recaptcha.parentElement.querySelector('[name="RecaptchaToken"]');

    element.value = response;

    $(element).valid();
}

function expiredCallback(response, recaptcha) {
    const element = recaptcha.parentElement.querySelector('[name="RecaptchaToken"]');

    element.value = '';

    $(element).valid();
}

function onloadCallback() {
    const recaptchas = document.querySelectorAll('.g-recaptcha');

    recaptchas.forEach(recaptcha => {
        console.log(recaptcha);

        window.grecaptcha.render(recaptcha, {
            'sitekey': recaptcha.dataset.sitekey,
            'theme': recaptcha.dataset.theme,
            'callback': function (response) {
                verifyCallback(response, recaptcha);
            },
            'expired-callback': function (response) {
                expiredCallback(response, recaptcha);
            }
        });
    });
}

window.verifyCallback = verifyCallback;
window.expiredCallback = expiredCallback;
window.onloadCallback = onloadCallback;